import react from 'react';


export const credientials = {

    //url for logic for sendign emails
    logicApp: 'https://prod-25.australiaeast.logic.azure.com:443/workflows/a30ec5eeae8c4b0db2ec63a3ce0459b8/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=O8w5IpvtZuj7qpYISgvRd2dIQfNY0L7-eO_jkn7rAwo',

    //host url for paymybill api call - dev
    //PayMyBillUrl: 'https://forms.cerebralpalsy.org.au/mobile-form/paymybill.php',
    //is url for add and chck invoice api calls - dev 
    //CheckInvoiceUrl: 'https://forms.cerebralpalsy.org.au/mobile-form/check-invoice.php',
    PayMyBillUrl: 'https://src.cerebralpalsy.org.au/api/paymybill.php',
    CheckInvoiceUrl: 'https://src.cerebralpalsy.org.au/api/check-invoice.php',
  };